import {createRoot, hydrateRoot} from 'react-dom/client';
import CloudAccounting from '../pages/CloudAccounting/CloudAccounting'
import "../index.css";
import "../pages/CloudAccounting/CloudAccounting.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<CloudAccounting {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <CloudAccounting {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).CloudAccountingVC = {mount, hydrate, unmount}